import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Fragment } from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
        textAlign: 'center',
        color: '#ffffff'
    },
    rowRoot: {
        '& .MuiTableCell-root': {
            padding: 0
        }
    },
    cellStyle: {
        borderBottom: 0,
        fontWeight: 700
    }
}));

function TotalPremium(props) {
    const classes = useStyles();
    const { premium, background } = props;
    const totalPremium = Math.round(premium);
    return(
        <div className={ classes.root } style={{ background: background }}>
            {
                props.isBottomPremium ?
                <TableContainer>
                    <Table aria-label="coverage-table">
                        <TableBody>
                            <TableRow className={ classes.rowRoot }>
                                <TableCell component="td" scope="row" style={{ color: '#ffffff' }} className={ classes.cellStyle }>Total Premium</TableCell>
                                <TableCell component="td" scope="row" align={ 'right' } style={{ color: '#ffffff' }} className={ classes.cellStyle }><span>P&nbsp;</span><span style={{ letterSpacing: 2 }}>{ totalPremium.toLocaleString() }</span></TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                :
                <Fragment>
                    <h3>Total Premium</h3>
                    <h3><span>P&nbsp;</span><span style={{ letterSpacing: 2 }}>{ totalPremium.toLocaleString() }</span></h3>
                </Fragment>
            }
            
        </div>
    )
}

export default TotalPremium;